import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    display: 'inline-flex',
  },
  savingText: {
    color: theme.palette.themePrimary,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(14),
    fontWeight: 400,
    marginLeft: pxToRem(10),
  },
});
